import React, { useContext } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { AttendanceContext } from '../../context/AttendanceContext';
import LinearProgressWithLabel from '../LinearProgressWithLabel';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

const Notice = styled.div`
    display: flex;
    align-items: center;
    max-width: 400px;
    justify-content: center;
    text-align: center;
    margin-top: 5rem;
    margin-bottom: 1rem;
`;

const Progress = styled.div`
    width: 250px;
`;

const AttendanceProgress: React.FC = () => {
    const { progress } = useContext(AttendanceContext);
    const { t } = useTranslation('attendance');

    return (
        <Container>
            <Notice>
                {t('generating-summaries')}
            </Notice>
            <Progress>
                <LinearProgressWithLabel value={progress} />
            </Progress>
        </Container>
    );
};

export default AttendanceProgress;
